export const withRetry = <T extends any[], R = any>(
  fn: (...args: T) => Promise<R>,
  {
    maxRetries = 3,
    shouldRetry = () => true,
    beforeRetry,
    onError,
  }: {
    maxRetries?: number;
    shouldRetry?: (error: any) => boolean;
    beforeRetry?: (error: any, ...args: T) => Promise<any>;
    onError?: (error: any) => any;
  }
) => {
  return async (...args: T): Promise<R> => {
    let retryCount = maxRetries;
    while (true) {
      try {
        return await fn(...args);
      } catch (error: any) {
        if (retryCount > 0 && shouldRetry(error)) {
          retryCount--;
          await beforeRetry?.(error, ...args);
        } else {
          if (onError) return onError(error);
          throw error;
        }
      }
    }
  };
};
